import { paymentRequestActionTypes } from '@Actions/paymentRequestActions';

const PaymentRequestReducers = (state = { }, action) => {
  switch (action.type) {
  case paymentRequestActionTypes.GET_PAYMENT_REQUEST.LOADING: {
    const { getPaymentRequestLoading } = action;
    return {
      ...state,
      getPaymentRequestLoading,
    };
  }
  case paymentRequestActionTypes.GET_PAYMENT_REQUEST.SUCCESS: {
    const { payments } = action;
    return {
      ...state,
      payments,
    };
  }
  case paymentRequestActionTypes.CREATE_PAYMENT_REQUEST.LOADING: {
    const { createPaymentRequestLoading } = action;
    return {
      ...state,
      createPaymentRequestLoading,
    };
  }
  case paymentRequestActionTypes.UPDATE_PAYMENTS_REQUEST.LOADING: {
    const { updatePaymentRequestLoading } = action;
    return {
      ...state,
      updatePaymentRequestLoading,
    };
  }

  default: {
    return state;
  }
  }
};

export default PaymentRequestReducers;
